<div class="container ps-0 ps-xxl-1" (mouseenter)="showItems = true">
  <div class="col text-start">
    @for (productGroup of browseGroups; track productGroup) {
      <div
        ngbDropdown
        class="d-inline-block position-relative"
        (mouseleave)="productGroup.open = false"
        >
        <button
          type="button"
          class="btn btn-outline-primary catalogItem border-0 me-2"
          [id]="productGroup.name"
          ngbDropdownToggle
          (mouseenter)="productGroup.open = true"
          >
          {{ productGroup.description }}
        </button>
        @if (showItems) {
          <div
            ngbDropdownMenu
            [attr.aria-labelledby]="productGroup.name"
            class="mt-0 py-0"
            [class.show]="productGroup.open"
            [class.longlist]="productGroup.sub_items?.length > 20"
            >
            @for (articleGroup of productGroup.sub_items; track articleGroup) {
              @if (articleGroup.sub_items?.length) {
                <div
                  ngbDropdown
                  class="d-block w-100"
                  (mouseleave)="articleGroup.open = false"
                  >
                  <button
                    ngbDropdownToggle
                    class="btn btn-outline-primary catalogItem border-0 w-100 text-start"
                (click)="
                  selectGroup(productGroup.name, articleGroup.name);
                  productGroup.open = false
                "
                    (mouseenter)="articleGroup.open = true"
                    >
                    {{ articleGroup.description }}
                  </button>
                  <div
                    ngbDropdownMenu
                    [attr.aria-labelledby]="articleGroup.name"
                    class="mt-0 position-absolute py-0"
                    style="left: 100%"
                [style.top]="
                  articleGroup.sub_items.length > 2
                    ? '-50px'
                    : articleGroup.sub_items.length == 2
                    ? '-20px'
                    : '-10px'
                "
                    [class.show]="articleGroup.open"
                    >
                    @for (articleSubGroup of articleGroup.sub_items; track articleSubGroup) {
                      @if (articleSubGroup.sub_items?.length) {
                        <div
                          ngbDropdown
                          class="d-block w-100"
                          (mouseleave)="articleSubGroup.open = false"
                          >
                          <button
                            ngbDropdownToggle
                            class="btn btn-outline-primary border-0 w-100 text-start"
                      (click)="
                        selectGroup(
                          productGroup.name,
                          articleGroup.name,
                          articleGroup.name
                        );
                        articleGroup.open = false
                      "
                            (mouseenter)="articleSubGroup.open = true"
                            >
                            {{ articleSubGroup.description }}
                          </button>
                          <div
                            ngbDropdownMenu
                            [attr.aria-labelledby]="articleSubGroup.name"
                            class="mt-0 position-absolute py-0"
                            style="left: 100%"
                      [style.top]="
                        articleSubGroup.sub_items.length > 2
                          ? '-50px'
                          : articleSubGroup.sub_items.length == 2
                          ? '-20px'
                          : '-10px'
                      "
                            [class.show]="articleSubGroup.open"
                            >
                            @for (subSubGroup of articleSubGroup.sub_items; track subSubGroup) {
                              <button
                                class="btn btn-outline-primary border-0 w-100 text-start"
                        (click)="
                          selectGroup(
                            productGroup.name,
                            articleGroup.name,
                            articleSubGroup.name,
                            subSubGroup.name
                          );
                          articleSubGroup.open = false
                        "
                                >
                                {{ subSubGroup.description }}
                              </button>
                            }
                          </div>
                        </div>
                      }
                      @if (!articleSubGroup.sub_items?.length) {
                        <button
                          class="btn btn-outline-primary border-0 w-100 text-start"
                    (click)="
                      selectGroup(
                        productGroup.name,
                        articleGroup.name,
                        articleSubGroup.name
                      );
                      productGroup.open = false;
                      articleGroup.open = false
                    "
                          >
                          {{ articleSubGroup.description }}
                        </button>
                      }
                    }
                  </div>
                </div>
              }
              @if (!articleGroup.sub_items?.length) {
                <button
                  class="btn btn-outline-primary border-0 w-100 text-start"
              (click)="
                selectGroup(productGroup.name, articleGroup.name);
                productGroup.open = false;
                articleGroup.open = false
              "
                  >
                  {{ articleGroup.description }}
                </button>
              }
            }
            <button
              class="btn btn-outline-primary border-0 w-100 text-start fw-bold"
          (click)="
            selectGroup(productGroup.name);
            productGroup.open = false
          "
              >
              {{ "VIEW_ALL" | translate }}
            </button>
          </div>
        }
      </div>
    }
    <div
      class="d-inline-block position-relative ng-star-inserted dropdown"
      ngbDropdown
      (mouseleave)="showPromotions = false"
      >
      <button
        ngbDropdownToggle
        class="dropdown-toggle btn btn-outline-primary catalogItem border-0 me-2"
        (mouseenter)="getPromotions()"
        >
        {{ "PROMOTIONS" | translate }}
      </button>

      <div ngbDropdownMenu class="mt-0 py-0" [class.show]="showPromotions">
        @if (promotions && promotions.length) {
          @for (groupedPromotions of promotions; track groupedPromotions) {
            @for (promotion of groupedPromotions; track promotion) {
              <button
                class="btn btn-outline-primary border-0 w-100 text-start"
              [innerHTML]="
                promotion.title === ''
                  ? promotion.promotioncode
                  : promotion.title
              "
              (click)="
                gotoSearchPage(
                  'CMN_PROM&HOMEPROMO=' +
                    promotion.promotioncode +
                    '&COMPANY=' +
                    +promotion.company_id,
                  $event
                )
              "
              ></button>
            }
          }
        }
        @if (promotions && !promotions.length && !promotionsLoaded) {
          <button class="px-3 py-1 dropdown-item btn">
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
        }
        @if (promotionsLoaded) {
          <button
            class="btn btn-outline-primary border-0 w-100 text-start fw-bold"
            (click)="gotoSearchPage('CMN_PROM', $event)"
            >
            {{ "VIEW_ALL" | translate }}
          </button>
        }
      </div>
    </div>
    <div class="d-inline-block position-relative ng-star-inserted dropdown">
      @if (showBom) {
        <button
          class="dropdown-toggle btn btn-outline-primary catalogItem border-0 hide-toggle me-2"
          (click)="gotoSearchPage('CMN_OLD,CMN_BOM', $event)"
          >
          {{ "BOM" | translate }}
        </button>
      }
    </div>
  </div>
</div>
